<template>
	<div class="cents">
		<van-nav-bar :title='$t("wlgl")' left-arrow safe-area-inset-top style="background-color: #1ABC9C;"
			@click-left="goto" />
		<div class="searchBtn" @click="bleSearch">{{this.$t('czsb')}}</div>
		<div class="searchBtn" v-if="deviceName" style="margin-top: -20px;">{{deviceName}}</div>
		<!-- wifi参数设置 -->
		<div class="section">
			<div class="section-title">
				<el-radio v-model="radio" label="1">{{this.$t('wifisz')}}</el-radio>
			</div>
			<div class="inputBox">
				<div class="inputBoxTitle">SSID:</div>
				<input v-model="wifi_ssid" :placeholder="this.$t('qsrSSID')" maxlength="20" />
			</div>
			<div class="inputBox">
				<div class="inputBoxTitle">{{this.$t('mm')}}:</div>
				<input v-model="wifi_pass" :placeholder="this.$t('qsrmm')" maxlength="20" />
			</div>
		</div>
		<div class="line"></div>
		<!-- 以太网参数设置 -->
		<div class="section">
			<div class="section-title">
				<el-radio v-model="radio" label="2">{{this.$t('ytwsz')}}</el-radio>
			</div>
			<div class="inputBox">
				<div class="inputBoxTitle">{{this.$t('DHCPms')}}:</div>
				<el-switch v-model="DHCPvalue" active-color="#13ce66"></el-switch>
			</div>
			<div class="inputBox">
				<div class="inputBoxTitle">{{this.$t('IPdz')}}:</div>
				<input v-model="net_ip" :placeholder="this.$t('qsrIP')" maxlength="20" value="" />
			</div>
			<div class="inputBox">
				<div class="inputBoxTitle">{{this.$t('zwym')}}:</div>
				<input v-model="net_mask" :placeholder="this.$t('qsrMASK')" maxlength="20" value="" />
			</div>
			<div class="inputBox">
				<div class="inputBoxTitle" >{{this.$t('wg')}}:</div>
				<input v-model="net_gateway" :placeholder="this.$t('qsrGATEWAY')" maxlength="20" value="" />
			</div>
		</div>
		<div class="line"></div>
		<!-- 4G设置 -->
		<div class="section4G">
			<div class="section-title" style="margin-right: 30px;padding-top: 3px;">
				<el-radio v-model="radio" label="3">{{this.$t('sgsz')}}</el-radio>
			</div>
			<el-switch v-model="DHCP4Gvalue" active-color="#13ce66"></el-switch>
		</div>
		<div class="line"></div>
		<div class="SubmitBtn" @click="SubmitBtn">{{this.$t('tjxg')}}{{radio}}</div>
	</div>
</template>

<script>
	import { Toast } from 'vant';
	var $ = require('../ble/jquery.min.js');
	var ble_helper = require('../ble/blehelper.js');
	var aes_encrypt  = require('../ble/aes.js');
	var indexs = require('../ble/index.js')
	var current_device = null;
	var current_key = '';
	
	export default {
		data() {
			return {
				deviceName: '', // 蓝牙连接的设备名
				radio: '', // 选择框绑定值
				DHCPvalue: false,
				DHCP4Gvalue: false,
				wifi_ssid:'',
				wifi_pass:'',
				net_ip:'', // 以太网ip
				net_mask:'', // 子网掩码
				net_gateway:'', // 网关
			}
		},
		methods: {
			// 提交按钮
			SubmitBtn() {
				if(this.deviceName==''){
					this.$message.info(this.$t('qxljsb'))
					return
				}
				if (this.radio == '') {
					this.$message.info(this.$t('qxzms'))
				} else if (this.radio == 1) {
					this.bleSetWifi()
				}else if(this.radio == 2){
					this.bleSetNetworkInfo()
				}else if(this.radio==3){
					this.bleEnable4G()
				}
			},
			// 网络参数
			bleSetWifi() {
				let that = this
				if (this.wifi_ssid.length == 0 || this.wifi_pass.length == 0) {
					alert("ssid or password"+this.$t('bnwk'));
					return;
				}
				console.log(ble_helper);
				console.log(`77`,current_device);
				console.log(`88`,current_key);
				// return
				ble_helper.ble_helper.open({
					device: current_device,
					key: current_key,
					onSuccess: function() {
						ble_helper.ble_helper.setNetworkMode({
							mode: 0,
							onSuccess(){
								ble_helper.ble_helper.setWifiSSID({
									ssid: that.wifi_ssid,
									onSuccess: function() {
										ble_helper.ble_helper.setWifiPassword({
											password: that.wifi_pass,
											onSuccess: function() {
												Toast.success(that.$t('wificsszcg'))
											},
											onFail: function(error) {
												Toast.fail(that.$t('mmszsb'))
											},
										});
									},
									onFail: function(error) {
										Toast.fail('ssid'+that.$t('szsb'))
									},
								});
							},
							onFail: function(error) {
									Toast.fail(that.$t('szwlmssb'))
							},
						});
					},
					onFail: function(error) {
						Toast.fail(that.$t('opentips'))
						ble_helper.ble_helper.setWifiSSID({
									ssid: that.wifi_ssid,
									onSuccess: function() {
										ble_helper.ble_helper.setWifiPassword({
											password: that.wifi_pass,
											onSuccess: function() {
												Toast.success(that.$t('wificsszcg'))
											},
											onFail: function(error) {
												Toast.fail(that.$t('mmszsb'))
											},
										});
									},
									onFail: function(error) {
										Toast.fail('ssid'+that.$t('szsb'))
									},
								});
					},
				});
			},
			// 设置以太网参数
			bleSetNetworkInfo(){
				let that = this
				if(this.net_ip.length == 0 || this.net_ip.length == 0 || this.net_mask.length == 0){
					alert(this.$t('ipdzbnwk'));
					return;
				}
				ble_helper.ble_helper.open({
					device: current_device,
					key: current_key,
					onSuccess: function(){
						ble_helper.ble_helper.setNetworkInfo({
							dhcpMode:that.DHCPvalue?1:0,
							ip: that.net_ip,
							gateway:that.net_gateway,
							mask:that.net_mask,
							onSuccess: function(){
								Toast.success(that.$t('ytwcsszcg'))
							},
							onFail: function(error){
								Toast.fail(that.$t('ytwcsszsb'))
							},
						});
					},
					onFail: function(error){
						Toast.fail(that.$t('opentips'))
					},
				});
			},
			// 4G
			bleEnable4G(){
				let that = this
				ble_helper.ble_helper.open({
					device: current_device,
					key: current_key,
					onSuccess: function(){
						ble_helper.ble_helper.enable4G({
							enabled: that.DHCP4Gvalue,
							onSuccess: function(){
								if(that.DHCP4Gvalue){
									Toast.success('4G'+that.$t('kqcg'))
								}else{
									Toast.success('4G'+that.$t('gbcg'))
								}
								console.log('enable4G成功');
							},
							onFail: function(error){
								console.log('enable4G失败', error);
								if(that.DHCP4Gvalue){
									Toast.fail('4G'+that.$t('kqsb'))
								}else{
									Toast.fail('4G'+that.$t('gbcg'))
								}
							},
						});
					},
					onFail: function(error){
						Toast.fail(that.$t('opentips'))
					},
				});
			},
			// 查找设备
			bleSearch() {
				current_device = null;
				console.log('Requesting any Bluetooth Device...');
				navigator.bluetooth.requestDevice({
						filters: [{
							namePrefix: 'awork'
						}],
						optionalServices: [
							'49535343-fe7d-4ae5-8fa9-9fafd205e455',
							"alert_notification",
							"automation_io",
							"battery_service",
							"blood_pressure",
							"body_composition",
							"bond_management",
							"continuous_glucose_monitoring",
							"current_time",
							"cycling_power",
							"cycling_power",
				  	"cycling_speed_and_cadence",
							"device_information",
							"environmental_sensing",
							"generic_access",
							"generic_attribute",
							"glucose",
							"health_thermometer",
							"heart_rate",
							"human_interface_device",
							"immediate_alert",
							"indoor_positioning",
							"internet_protocol_support",
							"link_loss",
				  	"location_and_navigation",
							"next_dst_change",
							"phone_alert_status",
							"pulse_oximeter",
							"reference_time_update",
							"running_speed_and_cadence",
							"scan_parameters",
							"tx_power",
							"user_data",
				   "weight_scale"
						]
					})
					.then(device => {
						current_device = device;
						console.log(current_device)
						this.deviceName = current_device.name.slice('6')
						// current_key = '4B08080A5D595345084B584D4E455C4D';
						this.getDeviceInfo(this.deviceName)
					})
					.catch(error => {
						console.log(error);
					});
			},
			// 返回上一页
			goto() {
				this.$router.go(-1)
			},
			// 获取设备信息接口
			getDeviceInfo(name) {
				let data = {
					method: 'fvcard.device.info.get',
					serial_number: name
				}
				this.$hscp(data).then(res => {
					console.log(res.data);
					if (res.data.code == 0) {
						current_key = res.data.data.btkey
					} else if (res.data.code == -3) {
						console.log('设备不存在')
					}
				})

			},
		}
	}
</script>

<style scoped>
	.SubmitBtn {
		width: 180px;
		height: 40px;
		margin: 20px auto;
		text-align: center;
		font-size: 16px;
		line-height: 40px;
		color: white;
		background-color: #1ABC9C;
		border-radius: 5px;
	}

	.section {
		padding: 0 50px;
	}

	.section4G {
		padding: 0 50px;
		display: flex;
	}

	.section-title {
		display: flex;
	}

	.inputBox {
		display: flex;
		margin: 12px 0;
	}

	.inputBoxTitle {
		width: 100px;
		text-align: left;
	}

	.searchBtn {
		width: 160px;
		height: 35px;
		background-color: #ddd;
		color: #000;
		margin: 20px auto;
		line-height: 35px;
		font-size: 15px;
		font-weight: bold;

	}

	.line {
		width: 90%;
		height: 1px;
		background-color: #ccc;
		margin: 30px auto;
	}

	.cents>>>.van-nav-bar__title {
		color: #fff;
	}

	.cents>>>.van-nav-bar .van-icon {
		color: #fff;
	}
</style>
